var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(-1774 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    transform: "translate(1774 9)",
    fill: "#fff",
    stroke: "#ee7404",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user01",
    transform: "translate(1782.955 16.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M91.1,8.136a3.936,3.936,0,0,0,2.876-1.192,3.936,3.936,0,0,0,1.192-2.876,3.936,3.936,0,0,0-1.192-2.876,4.067,4.067,0,0,0-5.752,0,3.936,3.936,0,0,0-1.192,2.876,3.936,3.936,0,0,0,1.192,2.876A3.937,3.937,0,0,0,91.1,8.136Zm0,0",
    transform: "translate(-84.161 0)",
    fill: "#2d335d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M14.056,252.145a10.047,10.047,0,0,0-.137-1.067A8.407,8.407,0,0,0,13.657,250a5.3,5.3,0,0,0-.441-1,3.776,3.776,0,0,0-.665-.867,2.933,2.933,0,0,0-.955-.6,3.3,3.3,0,0,0-1.22-.221,1.238,1.238,0,0,0-.661.28c-.2.129-.43.279-.689.444a3.946,3.946,0,0,1-.891.393,3.461,3.461,0,0,1-2.18,0,3.937,3.937,0,0,1-.891-.392c-.256-.164-.488-.313-.689-.444a1.236,1.236,0,0,0-.661-.28,3.3,3.3,0,0,0-1.22.221,2.93,2.93,0,0,0-.956.6A3.777,3.777,0,0,0,.874,249a5.309,5.309,0,0,0-.441,1,8.427,8.427,0,0,0-.262,1.073,10.012,10.012,0,0,0-.137,1.068c-.022.323-.034.659-.034,1a2.8,2.8,0,0,0,.833,2.122,3,3,0,0,0,2.146.783h8.132a3,3,0,0,0,2.146-.783,2.8,2.8,0,0,0,.833-2.122c0-.34-.012-.676-.034-1Zm0,0",
    transform: "translate(0 -239.158)",
    fill: "#2d335d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.fe2a7dae0da1e00eddfeeee4ed1ff9a1.svg";
export { ForwardRef as ReactComponent };